export default "__VITE_ASSET__TNZKeoIV__"